// ============================================================
// WISHLIST FUNCTIONALITY
// ============================================================
(function () {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('theme:wishlist') || '[]');
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('theme:wishlist', JSON.stringify(wishlist));
  }

  function updateButtonStates() {
    var wishlist = getWishlist();
    var wishlistDot = document.querySelector('.wishlist-dot');

    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      btn.classList.toggle('active', wishlist.includes(btn.getAttribute('data-product-id')));
    });

    if (wishlistDot) {
      wishlistDot.classList.toggle('is-visible', wishlist.length > 0);
    }

    document.querySelectorAll('.wishlist-count-bubble').forEach(function (bubble) {
      if (wishlist.length > 0) {
        bubble.textContent = wishlist.length;
        bubble.style.display = '';
      } else {
        bubble.style.display = 'none';
      }
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = 'true';

      btn.addEventListener('click', function () {
        var wishlist = getWishlist();
        var productId = this.getAttribute('data-product-id');

        if (wishlist.includes(productId)) {
          wishlist = wishlist.filter(function (item) { return item !== productId; });
          btn.classList.remove('active');
        } else {
          wishlist.unshift(productId);
          btn.classList.add('active');
        }

        saveWishlist(wishlist);
        updateButtonStates();

        var wishlistEl = document.querySelector('wishlist-products');
        if (wishlistEl) wishlistEl.loadProducts();
      });
    });

    updateButtonStates();
  }

  if (!window.customElements.get('wishlist-products')) {
    class WishlistProducts extends HTMLElement {
      constructor() {
        super();
        this.loadProducts();
      }

      buildQuery() {
        return getWishlist()
          .slice(0, this.productLimit)
          .map(function (id) { return 'id:' + id; })
          .join(' OR ');
      }

      async loadProducts() {
        var query = this.buildQuery();
        if (!query) { this.innerHTML = ''; return; }

        try {
          var response = await fetch(
            theme.routes.root_url + 'search?q=' + query +
            '&resources[limit]=' + this.productLimit +
            '&resources[type]=product&section_id=' + this.sectionId
          );
          var html = await response.text();
          var products = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('wishlist-products');
          if (products && products.hasChildNodes()) {
            this.innerHTML = products.innerHTML;
            initWishlistButtons();
          }
        } catch (e) {
          console.error('Wishlist load error:', e);
        }
      }

      get sectionId() { return this.getAttribute('section-id'); }
      get productLimit() { return parseInt(this.getAttribute('products-limit')) || 12; }
    }

    window.customElements.define('wishlist-products', WishlistProducts);
  }

  document.addEventListener('DOMContentLoaded', initWishlistButtons);
  window.initWishlistButtons = initWishlistButtons;
})();


// ============================================================
// QUOTE CART FUNCTIONALITY
// ============================================================
(function () {
  var QUOTE_KEY = 'quote:cart';
  var QUOTE_LAST_URL_KEY = 'quote:last-product-url';

  // ── Storage helpers ────────────────────────────────────────

  function getQuoteCart() {
    try { return JSON.parse(localStorage.getItem(QUOTE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveQuoteCart(cart) {
    localStorage.setItem(QUOTE_KEY, JSON.stringify(cart));
    updateQuoteBadge();
    renderQuoteList();
  }

  // ── Cart operations ────────────────────────────────────────

  function addToQuote(item) {
    var cart = getQuoteCart();
    var existing = cart.find(function (p) { return p.variantId === item.variantId; });
    if (existing) {
      existing.quantity = (existing.quantity || 1) + (item.quantity || 1);
    } else {
      item.quantity = item.quantity || 1;
      cart.unshift(item);
    }
    if (item.url) {
      localStorage.setItem(QUOTE_LAST_URL_KEY, item.url);
    }
    saveQuoteCart(cart);
  }

  function removeFromQuote(variantId) {
    saveQuoteCart(getQuoteCart().filter(function (p) { return p.variantId !== variantId; }));
  }

  function updateQuoteQty(variantId, qty) {
    var cart = getQuoteCart();
    if (qty <= 0) {
      cart = cart.filter(function (p) { return p.variantId !== variantId; });
    } else {
      var item = cart.find(function (p) { return p.variantId === variantId; });
      if (item) item.quantity = qty;
    }
    saveQuoteCart(cart);
  }

  // ── Badge ──────────────────────────────────────────────────

  function updateQuoteBadge() {
    var cart = getQuoteCart();
    var total = cart.reduce(function (sum, p) { return sum + (p.quantity || 1); }, 0);
    document.querySelectorAll('.quote-count-bubble').forEach(function (el) {
      el.textContent = total;
      el.style.display = total > 0 ? '' : 'none';
    });
  }

  // ── Render ─────────────────────────────────────────────────

  function formatMoney(cents) {
    if (!cents) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' Lei';
  }

  function renderQuoteList() {
    var listEl      = document.getElementById('quote-product-list');
    if (!listEl) return;

    var emptyEl     = document.getElementById('quote-empty-state');
    var noitemsEl   = document.getElementById('quote-form-noitems');
    var formWrapper = document.getElementById('quote-form-wrapper');
    var addMoreWrap = document.getElementById('quote-add-more-wrap');
    var cart        = getQuoteCart();

    if (cart.length === 0) {
      if (emptyEl)     emptyEl.style.display     = '';
      if (noitemsEl)   noitemsEl.style.display   = '';
      if (formWrapper) formWrapper.style.display  = 'none';
      if (addMoreWrap) addMoreWrap.style.display  = 'none';
      listEl.innerHTML = '';
      return;
    }

    if (emptyEl)     emptyEl.style.display     = 'none';
    if (noitemsEl)   noitemsEl.style.display   = 'none';
    if (formWrapper) formWrapper.style.display  = '';
    if (addMoreWrap) addMoreWrap.style.display  = '';

    listEl.innerHTML = cart.map(function (item) {
      var thumb = item.image
        ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="80" height="80">'
        : '<div class="quote-item-img-placeholder"></div>';

      var variantLabel = item.variant && item.variant !== 'Default Title'
        ? '<span class="quote-item-variant">' + item.variant + '</span>' : '';

      var priceLabel = item.price
        ? '<div class="quote-item-price">' + formatMoney(item.price) + '</div>' : '';

      return [
        '<div class="quote-item" data-variant-id="' + item.variantId + '">',
          '<div class="quote-item-image">' + thumb + '</div>',
          '<div class="quote-item-details">',
            '<a href="' + (item.url || '#') + '" class="quote-item-title">' + item.title + '</a>',
            variantLabel,
            priceLabel,
            '<div class="quote-item-qty form">',
              '<button type="button" class="quote-qty-btn quote-qty-minus" data-variant="' + item.variantId + '" aria-label="Scade cantitatea">&#x2212;</button>',
              '<input type="number" class="quote-qty-input" value="' + item.quantity + '" min="1" data-variant="' + item.variantId + '" aria-label="Cantitate">',
              '<button type="button" class="quote-qty-btn quote-qty-plus" data-variant="' + item.variantId + '" aria-label="Crește cantitatea">&#x2B;</button>',
            '</div>',
          '</div>',
          '<button type="button" class="quote-item-remove" data-variant="' + item.variantId + '" aria-label="Elimină">&#x2715;</button>',
        '</div>'
      ].join('');
    }).join('');

    listEl.querySelectorAll('.quote-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = this.dataset.variant;
        var item = getQuoteCart().find(function (p) { return p.variantId === vid; });
        if (item) updateQuoteQty(vid, (item.quantity || 1) - 1);
      });
    });

    listEl.querySelectorAll('.quote-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = this.dataset.variant;
        var item = getQuoteCart().find(function (p) { return p.variantId === vid; });
        if (item) updateQuoteQty(vid, (item.quantity || 1) + 1);
      });
    });

    listEl.querySelectorAll('.quote-qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        updateQuoteQty(this.dataset.variant, parseInt(this.value) || 1);
      });
    });

    listEl.querySelectorAll('.quote-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromQuote(this.dataset.variant);
      });
    });
  }

  // ── Form submit ────────────────────────────────────────────

  function initQuoteForm() {
    var form = document.getElementById('quote-request-form');
    if (!form || form.dataset.quoteFormInit) return;
    form.dataset.quoteFormInit = 'true';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var hiddenInput = document.getElementById('quote-products-json');
      if (hiddenInput) hiddenInput.value = JSON.stringify(getQuoteCart());

      var endpoint  = 'https://eurogastro.fastventures.dev/send-estimate';
      var submitBtn = form.querySelector('[type="submit"]');
      var msgEl     = document.getElementById('quote-form-message');

      if (msgEl) {
        msgEl.textContent = '';
        msgEl.className = 'quote-form-message';
        msgEl.style.display = 'none';
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-sending') || 'Se trimite...';
      }

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })
      .then(function (r) {
        return r.text().then(function (body) {
          var data = null;
          var contentType = (r.headers.get('content-type') || '').toLowerCase();

          if (body && (contentType.indexOf('application/json') !== -1 || body.trim().charAt(0) === '{')) {
            try {
              data = JSON.parse(body);
            } catch (err) {
              throw new Error('invalid-json');
            }
          }

          if (!r.ok) {
            var errorMessage = data && data.message
              ? data.message
              : 'Eroare la trimitere. Te rugam sa incerci din nou.';
            throw new Error(errorMessage);
          }

          if (!data || data.success !== true) {
            throw new Error((data && data.message) || 'Serverul a raspuns intr-un format neasteptat.');
          }

          return data;
        });
      })
      .then(function (data) {
        // Clear localStorage and reset UI
        saveQuoteCart([]);
        updateQuoteBadge();

        // Hide form, show only success message
        var formWrapper = document.getElementById('quote-form-wrapper');
        if (formWrapper) formWrapper.style.display = 'none';

        var successEl = document.getElementById('quote-success-state');
        if (successEl) {
          successEl.style.display = 'block';
        } else if (msgEl) {
          msgEl.textContent = data.message || 'Cererea a fost trimisa cu succes.';
          msgEl.className = 'quote-form-message quote-form-message--success';
          msgEl.style.display = 'block';
        }
      })
      .catch(function (error) {
        if (msgEl) {
          msgEl.textContent = error && error.message ? error.message : 'Eroare la trimitere. Te rugam sa incerci din nou.';
          msgEl.className = 'quote-form-message quote-form-message--error';
          msgEl.style.display = 'block';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Trimite cererea';
        }
      });
    });
  }

  // ── Product page: Add-to-quote button ──────────────────────

  function initAddToQuoteButtons() {
    document.querySelectorAll('[data-add-to-quote]').forEach(function (btn) {
      if (btn.dataset.quoteInit) return;
      btn.dataset.quoteInit = 'true';

      btn.addEventListener('click', function () {
        var container = this.closest('[data-quote-product]');
        if (!container) return;

        addToQuote({
          id:        container.dataset.productId,
          variantId: container.dataset.variantId,
          title:     container.dataset.title,
          variant:   container.dataset.variant,
          sku:       container.dataset.sku || '',
          image:     container.dataset.image,
          price:     parseInt(container.dataset.price) || 0,
          url:       container.dataset.url,
          quantity:  1
        });

        var redirectUrl = container.dataset.quoteRedirect;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          var feedback = container.querySelector('.quote-btn-feedback');
          if (feedback) {
            feedback.textContent = 'Produs adăugat';
            feedback.style.display = 'block';
            setTimeout(function () { feedback.style.display = 'none'; }, 2500);
          }
        }
      });
    });
  }

  // ── Public API ─────────────────────────────────────────────

  window.quoteCart = {
    add:    addToQuote,
    remove: removeFromQuote,
    update: updateQuoteQty,
    get:    getQuoteCart,
    clear:  function () { saveQuoteCart([]); }
  };

  window.initAddToQuoteButtons = initAddToQuoteButtons;

  // DOMContentLoaded may have already fired if the script loads late (Shopify section rendering)
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    renderQuoteList();
    initQuoteForm();
    initAddToQuoteButtons();
    updateQuoteBadge();

    // "Add more products" button — use last added product URL from localStorage
    var addMoreBtn = document.getElementById('quote-add-more-btn');
    if (addMoreBtn) {
      var explicitUrl = addMoreBtn.dataset.backUrl;
      var lastProductUrl = localStorage.getItem(QUOTE_LAST_URL_KEY);
      var targetUrl = (explicitUrl && explicitUrl !== '#') ? explicitUrl : lastProductUrl;
      if (targetUrl) {
        addMoreBtn.href = targetUrl;
      } else {
        addMoreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = '/collections/all';
          }
        });
      }
    }
  });

  // Re-init when Shopify theme editor re-renders a section (no full page reload occurs)
  document.addEventListener('shopify:section:load', function () {
    renderQuoteList();
    initQuoteForm();
    initAddToQuoteButtons();
    updateQuoteBadge();
  });
})();
